import React, { ReactNode, useEffect, useRef } from "react";
import { Button } from "wbm-inputs";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import CloseIcon from "@material-ui/icons/Close";
import "../../../sass/modalDialog.scss";
import ScrollBarService from "./ScrollBarService";
import { WBMLoader } from "wbm-loader";

export interface IModalPopupProps {
  closeIcon?: boolean;
  boxShadow?: boolean;
  header: string;
  button?: ReactNode;
  actionItem?: (event: React.MouseEvent) => void;
  actionItemText?: string;
  className?: string;
  maxWidth?: false | "xs" | "sm" | "md" | "lg" | "xl";
  btnClass?: string;
  setShow?: boolean;
  onClose?: () => void;
  disableBackdropClick?: boolean;
  showCancelButton?: boolean;
  customZIndex?: number;
  dangerButton?: boolean;
  isLoading?: boolean;
}

export function ModalPopup(props: React.PropsWithChildren<IModalPopupProps>) {
  const [open, setOpen] = React.useState<boolean>(props.setShow || false);
  const [isLoading, setIsLoading] = React.useState<boolean>(
    props.isLoading || false
  );
  const modalOpenApplied = useRef<boolean>(open);

  useEffect(() => {
    if (modalOpenApplied) {
      return () => {
        if (modalOpenApplied.current) {
          if (
            document.getElementsByClassName("main-slide-in-box").length <= 0
          ) {
            console.log("removing modal-open at unmount");
            ScrollBarService.applyModalOpen(false);
          } else {
            console.log("keeping modal-open as slidein is open");
            ScrollBarService.keepModalOpen(true);
          }
        }
      };
    } else {
      return;
    }
  }, [modalOpenApplied]);

  useEffect(() => {
    if (props.setShow !== undefined) {
      setOpen(props.setShow);
    }
  }, [props.setShow]);

  useEffect(() => {
    if (props.isLoading !== undefined) {
      setIsLoading(props.isLoading);
    }
  }, [props.isLoading]);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    if (props.onClose) {
      props.onClose();
    }
  };

  const handleBackdropClick = () => {
    if (!props.disableBackdropClick) {
      handleClose();
    }
  };

  const handleActionItem = (event: React.MouseEvent) => {
    setOpen(false);
    if (props.actionItem) {
      props.actionItem(event);
    }
  };

  let modalClass = "modal-parent";
  if (props.className) {
    modalClass += " " + props.className;
  }

  useEffect(() => {
    if (open === true) {
      ScrollBarService.applyModalOpen(true);
      modalOpenApplied.current = true;
    } else if (open === false) {
      if (document.getElementsByClassName("main-slide-in-box").length <= 0) {
        ScrollBarService.applyModalOpen(false);
      } else {
        console.log("keeping modal-open as slidein is open");
        ScrollBarService.keepModalOpen(true);
      }
      modalOpenApplied.current = false;
    }
  }, [open]);

  let zIndex = 1300;
  if (props.customZIndex) {
    zIndex = props.customZIndex;
  }

  return (
    <div className="modal-popup">
      <div className="sis-button" onClick={handleClickOpen}>
        {props.button}
      </div>
      <Dialog
        onClose={handleBackdropClick}
        aria-labelledby="simple-dialog-title"
        open={!!open}
        hideBackdrop
        className={modalClass}
        PaperProps={{
          style: {
            boxShadow: props.boxShadow ? "0px 3px 6px #00000029" : "none",
            border: "1px solid #D9D9DA",
            pointerEvents: isLoading ? "none" : "auto",
          },
        }}
        maxWidth={props.maxWidth}
        disableScrollLock
        style={{ zIndex: zIndex }}
      >
        <div className="header font-weight-bold">
          {props.header}{" "}
          {props.closeIcon ? (
            <CloseIcon onClick={handleClose} className="close-icon" />
          ) : null}
        </div>
        <div className="content">
          {isLoading && (
            <div className="overlay">
              <WBMLoader />
            </div>
          )}
          {props.children}
        </div>
        {props.actionItem ? (
          <DialogActions className="action-section">
            {props.showCancelButton && (
              <Button onClick={handleClose} className="btn-link">
                Cancel
              </Button>
            )}
            <Button
              onClick={handleActionItem}
              className={
                props.dangerButton ? "btn-primary danger" : "btn-primary"
              }
            >
              {props.actionItemText}
            </Button>
          </DialogActions>
        ) : null}
      </Dialog>
    </div>
  );
}
